import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

import { appearingAnimation } from "../../../shared/styles";

export const chartContainer = css`
    animation: ${appearingAnimation} 350ms ease;

    .recharts-surface {
        overflow: visible;
    }

    &:not([data-latest-bar-pending="false"]) .recharts-bar-rectangles .recharts-bar-rectangle:last-child {
        path {
            fill: ${Colors.Gray.V250};
            stroke: ${Colors.Black.V50};
            stroke-dasharray: 4;
            stroke-width: 2;

            &:hover,
            &:focus {
                fill: ${Colors.Yellow.V200};
            }
        }
    }
`;

// The SDS wrapper exposes no per-bar hook, so bars are addressed by position
// (one .recharts-bar-rectangle per datum); BarChartComponent.marker.spec guards that contract.
export const suppressedBars = (indices: readonly number[]): string | false =>
    indices.length > 0 &&
    css`
        ${indices
            .map((index) => `.recharts-bar-rectangles .recharts-bar-rectangle:nth-child(${index + 1}) path`)
            .join(",\n")} {
            fill: transparent;
            stroke: ${Colors.Black.V50};
            stroke-dasharray: 4;
            stroke-width: 2;

            &:hover,
            &:focus {
                fill: ${Colors.Yellow.V200};
            }
        }
    `;

export const emptyChartContainer = css`
    .recharts-line {
        display: none;
    }
`;

export const UTCNote = styled.div`
    ${Fonts.Paragraph.P300};
    margin-top: ${Spacing["2XL"]}px;
    color: ${Colors.Black.V50};
`;
